import _ from 'lodash';

export default class MetricAggregatesReportRequestInput {

    constructor(builder) {
        this.warehouseId = builder.warehouseId;
        this.shipmentTypes = builder.shipmentTypes;
        this.filterList = builder.filterList;
        this.metricAggregationRequest = builder.metricAggregationRequest;
    }

    static get Builder() {
        class Builder {
            withWarehouseId(warehouseId) {
                this.warehouseId = warehouseId;
                return this;
            }

            withShipmentTypes(shipmentTypes) {
                this.shipmentTypes = _.isArray(shipmentTypes) ? shipmentTypes : [shipmentTypes];
                return this;
            }

            withFilterList(filterList) {
                this.filterList = filterList;
                return this;
            }

            withMetricAggregationRequest(metricAggregationRequest) {
                this.metricAggregationRequest = metricAggregationRequest;
                return this;
            }

            build() {
                return new MetricAggregatesReportRequestInput(this);
            }
        }

        return Builder;
    }
}
